import { useRef } from 'react'

export default function CustomErrorDisplayWrapper() {
  const elementRef = useRef<HTMLElement>(null)

  return (
    <div className="fixed bottom-[50px] left-[50%] z-[100] flex h-auto w-auto translate-x-[-50%]">
      <custom-error-display ref={elementRef}></custom-error-display>
    </div>
  )
}
